import { useState, useCallback } from "react";
import { Check, Copy } from "lucide-react";

interface CopyMessageButtonProps {
  content: string;
}

export function CopyMessageButton({ content }: CopyMessageButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [content]);

  return (
    <button
      onClick={handleCopy}
      className="rounded-md p-1 text-intri-muted/40 hover:text-intri-dim transition-colors"
      aria-label="Copy message"
    >
      {copied ? (
        <Check size={12} className="text-intri-success/60" />
      ) : (
        <Copy size={12} />
      )}
    </button>
  );
}
